const inicialState = {
    showCarregando: false,
    recebimentoFinalizado: false,
    filtros: [],
    favoritos: [],
    listagem: [],
    heigth: 75,
    detalhes: undefined,
    laudoSelecionado: undefined,
    topografias: [],
    medicos: [],
    totalExamesAbertos: 0,
    totalExamesConcluidos: 0,
    visibilidadeModal: false,
    itemClicadoNaListagem: undefined,
    activeTab: "1",
    examesAbertos: [],
    inconformidades: [],
    historicoInconformidades: [],
    exames: [],
    exameSelecionado: undefined,
    tipoVinculoSelecionado: undefined,
    collapsedMenu: true,
    imprimiEtiquetaControle: false,
    exibirChecklistRecebimento: false,
    exibirTelaRecolhimento: false,
    imprimiEtiquetaAgora: false,
    habilitaCancelamento: false,
    listagemMultiplosExames: [],    
    modalRecolhimento: false,
    filtroLocalizacaoRegistroModalRecolhimento: undefined,
    existeNaoConformidadeImpeditiva: false,
    medicoExecutantePadrao: null,
    faturarMedicoPadrao: false,
    topografiaselecionada: null,
    medicoMicroscopistaSelecionado: null,
    quantidadeFrascos: 0,
}
export default inicialState;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/material.state.js